import Button from 'components/Button';
import { useTranslation } from 'react-i18next';
import { useCreateSectionMutation } from 'legacy/events/hooks';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

interface AddCategoryButtonProps {
  eventId: string;
  className?: string;
}

const AddCategoryButton: React.FC<AddCategoryButtonProps> = ({
  eventId,
  className
}) => {
  const { t } = useTranslation(['events']);
  const createSectionMutation = useCreateSectionMutation();

  return (
    <>
      {createSectionMutation.isLoading ? (
        <AiOutlineLoading3Quarters size={20} className="animate-spin" />
      ) : (
        <Button
          variant="secondary"
          className={className}
          onClick={() => {
            createSectionMutation.mutate({
              eventId,
              name: t('events:pricingTiers.categories.newCategory')
            });
          }}
        >
          + {t('events:pricingTiers.buttons.addCategory')}
        </Button>
      )}
    </>
  );
};

export default AddCategoryButton;
